<template>
  <div class="tabs">
    <ul>
      <li :class="{'is-active': link.router==activeLink}" v-for="link in nav" :key="link.name">
        <router-link :to="link.router">{{link.name}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: [
        {
          router: '/admin',
          name: 'Danh sách tài khoản'
        },
        {
          router: '/room-management',
          name: 'Danh sách phòng họp'
        },
        {
          router: '/import',
          name: 'Import'
        },
        {
          router: '/dkkh',
          name: 'Tạo tài khoản vận hành mới'
        },
        {
          router: '/locked-parties',
          name: 'Danh sách user RM bị khoá'
        },
        {
          router: '/party-management',
          name: 'Danh sách user'
        }
      ]
    }
  },
  props: {
    activeLink: {
      default: ''
    }
  }
}
</script>